module.exports = __webpack_public_path__ + "img/logo.7aa05f25.png";